<template>
  <div style="margin: 50px 50px 50px 50px">
    <h2 style="margin-bottom: 20px">
      {{ $store.state.storeClient.client.basicSettings.fullName }}
      ({{ $t("lmMainBrandName") }})
    </h2>
    <h3>
      {{ item.orderId }} ({{ item.fullName }})
      <span
        v-if="item.deliveryType == 'prepay'"
        style="
          margin-left: 5px;
          padding: 5px 10px 5px 10px;
          background-color: red;
          color: white;
        "
      >
        {{ $t("userOrdersSendEmailPrepaySubject") }}
      </span>
    </h3>
    <!-- PODATKI O PODJETJU -->
    <div style="margin-top: 20px" v-if="item.deliveryType == 'prepay'">
      <div>
        {{
          $store.state.storeClient.client.prepaySettings.prepayInfo
            .split("\n")
            .join(" | ")
        }}
      </div>
      <div class="margin1">
        {{ $t("userOrdersSendEmailReferenceSubject") }}:
        {{ item.qrCodeReference }}
      </div>
      <div style="margin-top: 5px" class="margin1">
        <strong>
          {{ $t("userOrdersFullSummary") }}:
          {{ price(item.deliveryFinalSum) }}
        </strong>
      </div>
    </div>
    <!-- PREVZEMNO MESTO IN NAČIN PLAČILA -->
    <div style="margin: 10px 0 10px 0">
      <v-icon small color="primary" class="mr-1 mb-1">mdi-walk</v-icon>
      {{ item.deliveryName }} /
      <v-icon small color="primary" class="mr-1 mb-1">mdi-account-cash</v-icon>
      {{ item.deliveryTypeString }}
    </div>
    <!-- OSTALI OSEBNI PODATKI -->
    <div style="margin-top: 20px" class="margin1">
      <div style="padding: 10px 15px 10px 15px; border: 1px solid gray">
        <div>
          <span v-if="item.isCompany">
            <v-icon small class="mr-2">mdi-numeric</v-icon>
            {{ item.vatNumber }}
          </span>
          <span>
            <v-icon small class="mr-2">mdi-face</v-icon>
            {{ item.fullName }}
          </span>
          <span>
            <v-icon small class="mr-2">mdi-home</v-icon>
            {{ item.address1 }}
          </span>
          <span>
            <v-icon small class="mr-2">mdi-city</v-icon>
            {{ item.address2 }}
          </span>
          <span>
            <v-icon small class="mr-2">mdi-flag</v-icon>
            {{ item.country }}
          </span>
        </div>
        <div style="margin-top: 5px">
          <span>
            <v-icon small class="mr-2">mdi-cellphone</v-icon>
            {{ item.phone }}
          </span>
          <span>
            <v-icon small class="mr-2">mdi-at</v-icon>
            {{ item.email }}
          </span>

          <!-- Formatiranje sporočil -->
          <div
            v-if="Array.isArray(item.messageForStudio)"
            class="mt-2 px-2 py-1"
            style="max-width: 400px; margin-top: 10px"
          >
            <div
              v-for="(item2, index) in item.messageForStudio"
              :key="index"
              class="pb-1"
            >
              <div
                class="pt-1 px-2 ma-0"
                style="font-size: 11px; font-style: italic"
              >
                {{ item2.fullName }}
                <span v-if="item2.timestamp.seconds !== undefined">
                  / {{ getMoment(item2.timestamp.seconds) }}</span
                >
              </div>
              <div class="pb-1 px-2">
                <v-icon small dark class="mr-2">mdi-message-reply-text</v-icon
                >{{ item2.msg }}
              </div>
            </div>
          </div>
          <div
            v-else-if="item.messageForStudio.length > 0"
            style="
              margin-top: 10px;
              max-width: 400px;
              background-color: red;
              color: white;
            "
          >
            <v-icon small dark class="mr-1">mdi-message-reply-text</v-icon>
            {{ item.messageForStudio }}
          </div>
        </div>
      </div>
    </div>
    <!-- IZRAČUN MODULA ZA RAZVIJANJE SLIK -->
    <div
      style="margin-top: 20px"
      v-if="
        item.storeCart.cart.filter((x) => x.module == G_MODULE_PHOTO_ORDER)
          .length > 0
      "
    >
      <div style="margin-bottom: 10px" class="lines">
        <span
          style="
            background-color: #404040;
            color: white;
            padding: 5px 10px 5px 10px;
          "
        >
          {{ getModuleName(G_MODULE_PHOTO_ORDER) }}
        </span>
      </div>
      <div
        v-for="cartItem in item.storeCart.cart.filter(
          (x) => x.module == G_MODULE_PHOTO_ORDER
        )"
        :key="cartItem.id"
      >
        <div
          v-for="cartItemData in cartItem.imageDataStr"
          :key="cartItemData.str"
        >
          <div>{{ cartItemData.str }}</div>
        </div>
      </div>
      <!-- povzetek cen razvijanja fotografij -->
      <div style="margin-top: 5px">
        {{ $t("userOrdersModPhotoOrderSummary") }} ({{
          item.storeCart.modPhotoOrderSummary.totalCopies
        }})
      </div>
      <div style="margin-top: 5px">
        {{ $t("userNewOrderSummary2Title") }}:
        {{ price(item.storeCart.modPhotoOrderSummary.totalSumLabPrice) }}
      </div>
      <div
        v-if="
          item.storeCart.modPhotoOrderSummary.totalSumQuantityDiscountPrice > 0
        "
        style="margin-top: 5px"
      >
        <div>
          {{ $t("userNewOrderSummary3Title") }}:
          {{
            price(
              item.storeCart.modPhotoOrderSummary.totalSumQuantityDiscountPrice
            )
          }}
          (-{{
            percent(
              item.storeCart.modPhotoOrderSummary.totalSumQuantityDiscount
            )
          }})
        </div>
        <div>
          {{ $t("userNewOrderSummary4Title") }}:
          {{ price(item.storeCart.modPhotoOrderSummary.totalSumQuantityPrice) }}
        </div>
      </div>
      <!-- morebitni extraCharge -->
      <div
        v-if="
          item.storeCart.modPhotoOrderSummary.totalSumExtraCharge >
          item.storeCart.modPhotoOrderSummary.totalSumQuantityPrice
        "
        class="mx-2"
        style="margin-top: 5px"
      >
        <div>
          {{ item.modulePhotoOrderExtraChargeMessage }}:
          {{ price(item.modulePhotoOrderExtraCharge) }}
        </div>
        <div>
          {{ $t("userNewOrderSummaryExtraChargeTitle") }}:
          {{ price(item.storeCart.modPhotoOrderSummary.totalSumExtraCharge) }}
        </div>
      </div>
      <!-- aktivna promo koda -->
      <div
        v-if="item.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscount > 0"
        style="margin-top: 5px"
      >
        <div>
          {{ $t("userNewOrderSummary5Title") }}:
          {{
            price(item.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscount)
          }}
          (-<span v-if="item.storeCart.activePromoCodeDiscountType == 'Pct'">{{
            percent(item.storeCart.activePromoCodeDiscount)
          }}</span
          ><span
            v-else-if="item.storeCart.activePromoCodeDiscountType == 'Amt'"
            >{{ price(item.storeCart.activePromoCodeDiscount) }}</span
          >)
        </div>
        <div>
          {{ $t("userNewOrderSummary5cTitle") }}:
          {{
            price(
              item.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscountPrice
            )
          }}
        </div>
      </div>
    </div>
    <!-- IZRAČUN MODULA ZA FOTO IZDELKE -->
    <div
      style="margin-top: 20px"
      v-if="
        item.storeCart.cart.filter((x) => x.module == G_MODULE_PHOTO_GIFT)
          .length > 0
      "
    >
      <div style="margin-bottom: 10px" class="lines">
        <span
          style="
            background-color: #404040;
            color: white;
            padding: 5px 10px 5px 10px;
          "
        >
          {{ getModuleName(G_MODULE_PHOTO_GIFT) }}
        </span>
      </div>
      <div
        v-for="cartItem in item.storeCart.cart.filter(
          (x) => x.module == G_MODULE_PHOTO_GIFT
        )"
        :key="cartItem.id"
      >
        <div class="my-1">
          {{ cartItem.itemName }}
          {{ cartItem.imageDataStr }}
        </div>
      </div>
      <!-- povzetek cen -->
      <div style="margin-top: 5px">
        {{ $t("userOrdersModPhotoGiftSummary") }} ({{
          item.storeCart.modPhotoGiftSummary.totalCopies
        }})
      </div>
      <div style="margin-top: 5px">
        {{ $t("userNewOrderSummary2Title") }}:
        {{ price(item.storeCart.modPhotoGiftSummary.totalSumLabPrice) }}
      </div>
      <!-- morebitni extraCharge -->
      <div
        v-if="
          item.storeCart.modPhotoGiftSummary.totalSumExtraCharge >
          item.storeCart.modPhotoGiftSummary.totalSumLabPrice
        "
        style="margin-top: 5px"
      >
        <div>
          {{ item.modulePhotoGiftExtraChargeMessage }}:
          {{ price(item.modulePhotoGiftExtraCharge) }}
        </div>
        <div>
          {{ $t("userNewOrderSummaryExtraChargeTitle") }}:
          {{ price(item.storeCart.modPhotoGiftSummary.totalSumExtraCharge) }}
        </div>
      </div>
      <!-- aktivna promo koda -->
      <div
        v-if="item.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscount > 0"
        style="margin-top: 5px"
      >
        <div>
          {{ $t("userNewOrderSummary5Title") }}:
          {{
            price(item.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscount)
          }}
          <span v-if="$store.state.storeCart.activePromoCodeSuperCategory != ''"
            >/
            {{ $store.state.storeCart.activePromoCodeSuperCategoryName }}</span
          >
          <span v-if="$store.state.storeCart.activePromoCodeCategory != ''">
            /
            {{ $store.state.storeCart.activePromoCodeCategoryName }}</span
          >
          <span v-if="$store.state.storeCart.activePromoCodeItem != ''"
            >/ {{ $store.state.storeCart.activePromoCodeItemName }}</span
          >
          <span v-if="$store.state.storeCart.activePromoCodeSubItem != ''">
            /
            {{ $store.state.storeCart.activePromoCodeSubItemName }}</span
          >
          (-<span v-if="item.storeCart.activePromoCodeDiscountType == 'Pct'">{{
            percent(item.storeCart.activePromoCodeDiscount)
          }}</span
          ><span
            v-else-if="item.storeCart.activePromoCodeDiscountType == 'Amt'"
            >{{ price(item.storeCart.activePromoCodeDiscount) }}</span
          >)
        </div>
        <div>
          {{ $t("userNewOrderSummary5cTitle") }}:
          {{
            price(
              item.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice
            )
          }}
        </div>
      </div>
    </div>
    <v-divider
      v-if="
        item.storeCart.activePromoCodeActivated ||
        item.deliveryExtraChargeInfo > 0
      "
      style="margin-top: 5px"
    ></v-divider>
    <!-- PROMO KODA -->
    <div v-if="item.storeCart.activePromoCodeActivated" style="margin-top: 5px">
      <div>
        {{ $t("userNewOrderSummary5aTitle") }}:
        <strong>
          {{ item.storeCart.activePromoCode.toUpperCase() }}
        </strong>
        /
        {{ getModuleName(item.storeCart.activePromoCodeModule) }}
        <span v-if="$store.state.storeCart.activePromoCodeSuperCategory != ''"
          >/ {{ $store.state.storeCart.activePromoCodeSuperCategoryName }}</span
        >
        <span v-if="$store.state.storeCart.activePromoCodeCategory != ''">
          /
          {{ $store.state.storeCart.activePromoCodeCategoryName }}</span
        >
        <span v-if="$store.state.storeCart.activePromoCodeItem != ''"
          >/ {{ $store.state.storeCart.activePromoCodeItemName }}</span
        >
        <span v-if="$store.state.storeCart.activePromoCodeSubItem != ''">
          /
          {{ $store.state.storeCart.activePromoCodeSubItemName }}</span
        >
        (-<span v-if="item.storeCart.activePromoCodeDiscountType == 'Pct'">{{
          percent(item.storeCart.activePromoCodeDiscount)
        }}</span
        ><span
          v-else-if="item.storeCart.activePromoCodeDiscountType == 'Amt'"
          >{{ price(item.storeCart.activePromoCodeDiscount) }}</span
        >)
      </div>
      <div>
        {{ $t("userNewOrderSummary5dTitle") }}:
        {{ price(item.storeCart.totalSumPromoCodeDiscount) }}
      </div>
    </div>
    <!-- DODATNI STROŠKI -->
    <div v-if="item.deliveryExtraChargeInfo > 0" style="margin-top: 5px">
      <v-divider class="my-1"></v-divider>
      <div style="margin-top: 5px">
        {{ $t("userNewOrderSummary6Title") }}:
        {{ price(item.storeCart.totalSumCart) }}
      </div>
      <div>
        {{ item.deliveryExtraChargeMessage }}:
        {{ price(item.deliveryExtraChargeInfo) }}
      </div>
    </div>
    <v-divider style="margin-top: 5px"></v-divider>
    <div style="margin-top: 5px">
      <strong>
        {{ $t("userOrdersFullSummary") }}:
        {{ price(item.deliveryFinalSum) }}
      </strong>
    </div>
  </div>
</template>

<script>
import {
  G_MODULE_PHOTO_ORDER,
  G_MODULE_PHOTO_GIFT,
  G_MODULE_ALL,
} from "@/constants";
import moment from "moment";

export default {
  name: "export-order-info",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getMoment(item) {
      return moment.unix(item).format("DD.MM.YY HH:mm");
    },
  },
  created() {
    this.G_MODULE_PHOTO_ORDER = G_MODULE_PHOTO_ORDER;
    this.G_MODULE_PHOTO_GIFT = G_MODULE_PHOTO_GIFT;
    this.G_MODULE_ALL = G_MODULE_ALL;
  },
};
</script>